export default {
  home: 'Home',
  menu: 'Menü',
  orders: 'Bestellungen',
};
